import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Button, useStickySafeNavigate } from '@equifinance/shared';
import Page from '../components/Page';

const CommitmentsContainer = styled.div`
  display:flex;
  flex-direction: column;
  align-items:flex-end;
  width:100%;
`;

const SubmitButton = styled(Button)`${({ theme }) => `
  margin:${theme.padding[2]};
  width:20vw;
  max-width:300px;
`}`;

function Commitments() {
  const { id } = useParams() as {id: string};

  const navigate = useStickySafeNavigate();

  const onClickSubmit = () => {
    navigate(`/download-esis/${id}`);
  };

  return (
    <Page>
      <CommitmentsContainer>
        <SubmitButton onClick={onClickSubmit}>Submit</SubmitButton>
      </CommitmentsContainer>
    </Page>
  );
}

export default Commitments;
